strictIndexOf